// Module
var code = `<div class="rb-video rb-widget"><div class="rb-title"><i class="ficon-app-video"></i><span translate="rubric-widget-video_video-response"></span></div></div>`;
// Exports
export default code;